export default __webpack_public_path__ + "static/media/32a87b1a2d449a72.f6ad25e195c7e0f927d92f4241d8e905.svg";